export const privacyPolicyData = {
  title: 'Privacy Policy',
  subtitle:
    'Your privacy matters to us. This policy explains how KU Contractors Limited collects, uses, and protects your information to deliver trusted construction and maintenance services.',
  sections: [
    {
      id: 1,
      icon: 'Lock',
      title: '1. Information We Collect',
      content: [
        'We may collect the following types of information:',
        'Personal details such as your name, email, phone number, and address.',
        'Service or project details you share with us for quotes or bookings.',
        'Website usage information like IP address and browser data (via cookies).',
      ],
    },
    {
      id: 2,
      icon: 'FileText',
      title: '2. How We Use Your Information',
      content: [
        'To provide, improve, and maintain our services.',
        'To communicate with you regarding inquiries, quotes, and project updates.',
        'To ensure a secure, personalized, and efficient service experience.',
        'To comply with legal and contractual obligations.',
      ],
    },
    {
      id: 3,
      icon: 'ShieldCheck',
      title: '3. Data Sharing & Security',
      content: [
        'We never sell your data. However, we may share it with trusted service partners or legal authorities when necessary. We implement strong security measures to protect your information from unauthorized access or misuse.',
      ],
    },
    {
      id: 4,
      icon: 'UserCheck',
      title: '4. Your Rights',
      content: [
        'Access, correct, or delete your personal information.',
        'Opt out of marketing communications anytime.',
        'Request details about how your data is being used.',
      ],
    },
    {
      id: 5,
      icon: 'Cookie',
      title: '5. Cookies',
      content: [
        'Our website may use cookies to enhance user experience. You can disable cookies through your browser settings, but some features may not function as intended.',
      ],
    },
    {
      id: 6,
      icon: 'PhoneCall',
      title: '6. Contact Us',
      content: [
        'For any questions about this Privacy Policy or how we manage your data, reach out to us:',
        'Email:office@kucontractors.com',
        'Phone: 07454-926-222',
        'Address:  125A Crossbrook Street, Cheshunt, Hertfordshire, United Kingdom, EN8 8LY',
      ],
    },
  ],
  footer: {
    rights: '© KU Contractors Limited. All rights reserved.',
    updated: 'Last updated: November 2025',
  },
};
